import {
  FC,
  ReactNode,
  createContext,
  useState,
  Dispatch,
  SetStateAction,
} from "react";

interface Prop {
  children?: ReactNode;
}

interface ChatContextType {
  chatOpen: boolean;
  setChatOpen: Dispatch<SetStateAction<boolean>>;
}

const ChatContext = createContext<ChatContextType | null>(null);
const ChatContextProvider: FC<Prop> = ({ children }) => {
  const [chatOpen, setChatOpen] = useState(false);

  return (
    <ChatContext.Provider value={{ chatOpen, setChatOpen }}>
      {children}
    </ChatContext.Provider>
  );
};

export { ChatContext, ChatContextProvider };
